export const api = {
  manage: {
    queryDeptTree: '/vas/dept/queryDeptTree.json', // 查询所有部门和部门下面的人员信息接口
    queryPersonnelListByDeptCode: '/vas/personnel/queryPersonList.json', // 查询部门下面的人员信息
    addVehicle: '/bas/addVehicle/addVehicle', // 新增车辆信息
    updateVehicle: '/bas/addVehicle/updateVehicle', // 修改车辆信息
    queryVehicleList: '/bas/queryVehicle/queryVehicleList', // 查询车辆信息
    deleteVehicle: '/bas/addVehicle/deleteVehicle', // 删除车辆信息
    queryParkLotList: '/bas/queryVehicle/queryDepotLotList', // 查询停车场列表
    queryVehicle: '/bas/queryVehicle/queryVehicle', // 获取详情信息
  },
  record: {
    record: '/bas/vehicleHisRecord/queryVehicleHisRecordList', // 车辆进出数据
    updateVehicleHisRecordList: '/bas/vehicleHisRecord/updateVehicleHisRecordList.json', // 车辆进出数据
  },
  control: {
    control: '/bas/queryParkingControl/queryParkingControl' // 查询车场的车位及余位信息
  }
}
